import React from 'react';
import { Button, Grid, Paper, Typography } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { OrderPageData } from '../../api';
import { useSaveHeader } from '../saveHeader/SaveHeaderContext';
import { SettingsPageTabs } from '../SettingsPageTabs';

type Props = {
  orderPage: OrderPageData;
};

export const EventSchedulePresetsPanel = ({ orderPage }: Props) => {
  const { t } = useTranslation();
  const { setActiveTab, requestTabChange } = useSaveHeader();

  const goToSettings = async () => {
    const ok = await requestTabChange(SettingsPageTabs.SETTINGS);
    if (!ok) return;
    setActiveTab(SettingsPageTabs.SETTINGS);
    window.location.hash = `#${SettingsPageTabs.SETTINGS}`;
    setTimeout(() => {
      document.getElementById('default-tickets-amount-row')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 150);
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, width: '100%', maxWidth: 720 }}>
      <Grid container gap={1} alignItems="center" justifyContent="space-between" flexWrap="wrap">
        <Grid item xs>
          <Typography variant="subtitle2" fontWeight={700}>
            {t('eventSchedule.presetsTitle')}
          </Typography>
          <Grid container gap={1} alignItems="baseline" mt={0.5}>
            <Typography variant="body2" color="text.secondary">
              {t('eventSchedule.presetsTickets')}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {orderPage.default_tickets_amount ?? '—'}
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Button size="small" variant="outlined" endIcon={<OpenInNew />} onClick={goToSettings}>
            {t('eventSchedule.editInSettings')}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};
